import React from 'react';
import { useDispatch } from 'react-redux';
import Leagues from '../../../shared/Events/Filters/Leagues/Leagues';
import Orders from '../../../shared/Events/Filters/Orders/Orders';
import { changeFavoritesEventType } from '../../../../store/actions/favorites';

const LiveFilters = () => {
    const dispatch = useDispatch();

    const onOrderChange = value => {
        dispatch(changeFavoritesEventType(value.value));
    };

    return (
        <div className={'filter-area'}>
            <div className={'filter-grid'} style={{ width: '30%' }}>
                <Leagues />
            </div>
            <div className={'filter-grid'} style={{ width: '20%' }}>
                <Orders onChange={onOrderChange} />
            </div>
        </div>
    );
};

export default LiveFilters;
